'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmModal = function ConfirmModal(_ref) {
  var visible = _ref.visible,
      onOK = _ref.onOK,
      onCancel = _ref.onCancel,
      children = _ref.children;
  return _react2.default.createElement(
    _index2.default,
    { visible: visible },
    _react2.default.createElement(
      'div',
      { className: 'modal-header' },
      _react2.default.createElement(
        'h5',
        { className: 'modal-title' },
        'Confirmation'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal-body' },
      children
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal-footer' },
      _react2.default.createElement(
        'button',
        { type: 'button', className: 'btn btn-secondary', onClick: onCancel },
        'Cancel'
      ),
      _react2.default.createElement(
        'button',
        { type: 'button', className: 'btn btn-primary', onClick: onOK },
        'OK'
      )
    )
  );
};

ConfirmModal.propTypes = {
  children: _propTypes2.default.node.isRequired,
  visible: _propTypes2.default.bool.isRequired,
  onOK: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired
};

exports.default = ConfirmModal;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap4-modal/lib/ConfirmModal.js
// module id = 594
// module chunks = 0